/** IndexedDB 的最小封装：一个 key-value 表，存本地数据快照。浏览器不支持或出错时静默降级为不持久化。 */

const DB_NAME = "kids-planner-web";
const STORE = "kv";

let dbPromise: Promise<IDBDatabase | null> | null = null;

function open(): Promise<IDBDatabase | null> {
  if (typeof indexedDB === "undefined") return Promise.resolve(null);
  if (!dbPromise) {
    dbPromise = new Promise((resolve) => {
      const req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = () => {
        if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE);
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => {
        console.warn("[idb] 打开失败", req.error);
        resolve(null);
      };
      req.onblocked = () => resolve(null);
    });
  }
  return dbPromise;
}

function run<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T> | void): Promise<T | undefined> {
  return open().then(
    (db) =>
      new Promise<T | undefined>((resolve) => {
        if (!db) return resolve(undefined);
        try {
          const tx = db.transaction(STORE, mode);
          const req = fn(tx.objectStore(STORE));
          tx.oncomplete = () => resolve(req ? req.result : undefined);
          tx.onerror = () => {
            console.warn("[idb] 读写失败", tx.error);
            resolve(undefined);
          };
        } catch (e) {
          console.warn("[idb] 读写失败", e);
          resolve(undefined);
        }
      }),
  );
}

export const idb = {
  get<T>(key: string): Promise<T | undefined> {
    return run<T>("readonly", (s) => s.get(key) as IDBRequest<T>);
  },
  async set(key: string, value: unknown): Promise<void> {
    await run("readwrite", (s) => {
      s.put(value, key);
    });
  },
  async del(key: string): Promise<void> {
    await run("readwrite", (s) => {
      s.delete(key);
    });
  },
  async clear(): Promise<void> {
    await run("readwrite", (s) => {
      s.clear();
    });
  },
};
